export enum DELIVERY_STATUS_TYPE {
  Success = 1,
  Failed,
  Queued,
  InProgress,
  Other,
}
